export default __webpack_public_path__ + "static/media/a04.d625b6c3.jpg";